import * as React from 'react';

import MuiStepper from '@material-ui/core/Stepper';


const Stepper = props => {
  const { children, ...rest } = props;
  return <MuiStepper {...rest}>{children}</MuiStepper>;
};

export { Stepper };
